import type {
  CommunityBoardFeedCursor,
  CommunityBoardFeedItem,
  CommunityBoardFeedResult,
} from "./communityBoardFeed";
import { mergeUniqueItems } from "./communityBoardState";

/** Fill the visible feed, including pinned notices shared with the sidebar. */
export async function fillCommunityStories(
  fetchPage: (
    cursor: CommunityBoardFeedCursor | null,
  ) => Promise<CommunityBoardFeedResult>,
  initialItems: CommunityBoardFeedItem[],
  cursor: CommunityBoardFeedCursor | null,
  target: number,
  isCurrent: () => boolean,
): Promise<CommunityBoardFeedResult> {
  let items = initialItems;
  let result: CommunityBoardFeedResult;
  do {
    result = await fetchPage(cursor);
    const merged = mergeUniqueItems(
      items,
      result.results,
      (item) => `${item.kind}-${item.id}`,
    );
    const progressed = merged.length > items.length;
    items = merged;
    cursor = result.cursor;
    if (!progressed || !isCurrent()) break;
  } while (
    result.hasMore &&
    cursor &&
    items.length < target
  );
  return { ...result, results: items };
}
